import { call, put, select, takeLeading, takeLatest } from "redux-saga/effects";
import { getProductList } from "../../../api/homeApi";
import {
  failedToFetchRecentlyViewedAction,
  requestToFetchRecentlyViewedAction,
  responseFromFetchRecentlyViewedAction,
} from "../../slices/commonSlice";
import { getCurrencyFlagIcon, getSavedAddresses, initiateFusApiCall } from "../../../api/common";
import { initiateFus, setFusData } from "../../slices/common/fus";
import { responseGetCartItemsCount } from "../../slices/cartSlice";

import {
  failedToGetCurrency,
  requestToGetCurrency,
  requestToGetCurrencyFlagIcon,
  requestToSaveCurrency,
  requestToSaveSelectedCurrency,
  saveCurrencyFlagIcon,
  setEdgeHeader,
} from "../../slices/common/currencyLists";
import { getCurrencyList } from "../../../api/common";
import CookieUtil from "../../../utils/storage/cookieUtil";
import { CURRENCY_ID, LOCAL_CURRENCY } from "../../../constants/common/common";
import { requestToSavedAddress, savedAddressError, setSavedAddress } from "../../slices/savedAddresses";
import { getUserLocalCurrency } from "../../../utils/common";
import { execDataLayer } from "../../../utils/cache-layer/cacheLayer";
import { endpointConst } from "../../../utils/cache-layer/cacheLayerConstants";
import {
  requestToGetPartnerInfo,
  requestToSetPartnerInfoFailure,
  requestToSetPartnerInfoSuccess,
} from "../../slices/partner";
import { getIsPartnerLinked } from "../../../api/common";
/**
 *
 * @param {*} action
 */
function* fetchProductListSaga() {
  try {
    const response = yield getProductList();
    if (response?.data) {
      if (response?.data?.productResults?.length > 0) {
        yield put(responseFromFetchRecentlyViewedAction(response?.data?.productResults));
      } else {
        yield put(responseFromFetchRecentlyViewedAction([]));
      }
    } else {
      yield put(failedToFetchRecentlyViewedAction({ message: "Earliest delivery dates not found", code: 404 }));
    }
  } catch (error) {
    yield put(failedToFetchRecentlyViewedAction(error));
  }
}
/**
 * Generator function to call fus api call which gets the login details, cart quantity and pincode details of customer .
 *
 */
export function* initiateFusCall() {
  try {
    const response = yield call(initiateFusApiCall);
    if (response?.checklogin?.loggedin) {
      window.userDetails = response;
    }
    yield put(setFusData(response));
    yield put(responseGetCartItemsCount(response?.cart?.cartTotalQuantity));
    const pathname = typeof window !== "undefined" ? window.location.pathname : "";
    const isMyAccountPage = /\/account(\/|$)/.test(pathname);
    if (response?.checklogin?.loggedin && !isMyAccountPage) {
      yield put(requestToSavedAddress());
    }
  } catch (error) {
    // yield put({ type: SET_ERROR, payload: error });
  }
}

/** */
export function* setCurrencyListToStoreSaga({ payload }) {
  try {
    const response = payload?.currencies
      ? payload
      : yield call(execDataLayer, getCurrencyList, endpointConst.currencyList);
    const currencies = response?.currencies;

    if (!currencies) {
      return;
    }

    yield put(requestToSaveCurrency(currencies));

    const cookieCurrencyId = CookieUtil.getCookie(LOCAL_CURRENCY);
    const edgeHeader = payload?.edgeHeader
      ? payload?.edgeHeader
      : (response?.headers?.["x-akamai-edgescape"] ?? response?.headers?.["X-Akamai-Edgescape"]);

    yield put(setEdgeHeader(edgeHeader || ""));

    const localCurrencyId = getUserLocalCurrency(edgeHeader, currencies);
    const selectedCurrencyId = localCurrencyId && !cookieCurrencyId ? localCurrencyId : cookieCurrencyId || CURRENCY_ID;

    CookieUtil.setCookie(LOCAL_CURRENCY, selectedCurrencyId, { path: "/", sameSite: "lax", secure: true });
    const userSelectedCurrency = currencies.find((item) => item.currency.id === selectedCurrencyId);

    yield put(requestToSaveSelectedCurrency(userSelectedCurrency));
  } catch (error) {
    yield put(failedToGetCurrency(error));
  }
}

/**
 * to fetch currency flag and icon data from API
 * and dispatch it to the store if the response is valid.
 */
export function* fetchCurrencyFlagIcon() {
  const response = yield getCurrencyFlagIcon();
  if (Array.isArray(response)) {
    yield put(saveCurrencyFlagIcon(response));
  }
}

/** */
function* fetchSavedAddresses(action) {
  const hasFetched = yield select((state) => state?.savedAddress?.hasSavedAddressesFetched);

  if (hasFetched && !action?.payload?.force) {
    return;
  }

  try {
    const response = yield call(getSavedAddresses);
    const addressList = response?.addressList ?? response?.data?.addressList;
    yield put(setSavedAddress(Array.isArray(addressList) ? addressList : undefined));
  } catch (error) {
    yield put(savedAddressError(error));
  }
}

/**
 * Fetches partner info from the API and dispatches it to the store.
 */
export function* fetchPartnerInfo(action) {
  try {
    const response = yield call(getIsPartnerLinked, action?.payload?.partnerId);
    if (response?.status === 200 && response?.isSuccess) {
      yield put(
        requestToSetPartnerInfoSuccess({
          linked: response.linked,
          membershipId: response.membershipId,
          partnerLogoUrl: response.partnerLogoUrl,
          partnerId: response?.partnerId,
          partnerName: response?.partnerName,
        }),
      );
    } else {
      yield put(requestToSetPartnerInfoFailure());
    }
  } catch (error) {
    yield put(requestToSetPartnerInfoFailure());
  }
}

/**
 * Description placeholder
 *
 * @export
 * @returns {{}}
 */
export function* watcherFetchCommonSaga() {
  yield takeLatest(requestToFetchRecentlyViewedAction.type, fetchProductListSaga);
  yield takeLatest(initiateFus.type, initiateFusCall);
  yield takeLeading(requestToSavedAddress.type, fetchSavedAddresses);
  yield takeLatest(requestToGetCurrency.type, setCurrencyListToStoreSaga);
  yield takeLatest(requestToGetCurrencyFlagIcon.type, fetchCurrencyFlagIcon);
  yield takeLatest(requestToGetPartnerInfo.type, fetchPartnerInfo);
}
